import axios from "axios";
import * as ActionTypes from "./actionTypes";
import * as urls from "../common/urls";

export function getCustomerAvailableLoyaltyPointsBalance() {
    const request = axios.get(
        urls.GET_CUSTOMER_AVAILABLE_LOYALTY_POINTS_BALANCE,
        { headers: { "Content-Type": "application/json" } }
    );
    return { type: ActionTypes.GET_CUSTOMER_AVAILABLE_LOYALTY_POINTS_BALANCE, payload: request };
}

export function getCustomerLoyaltyTransactions() {
    const request = axios.get(
        urls.GET_CUSTOMER_LOYALTY_TRANSACTIONS,
        { headers: { "Content-Type": "application/json" } }
    );
    return { type: ActionTypes.GET_CUSTOMER_LOYALTY_TRANSACTIONS, payload: request };
}
